module.exports = __webpack_public_path__ + "img/recovery-error.a0fd7327.svg";